"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alert = void 0;
const react_1 = __importDefault(require("react"));
const view_1 = require("../html-widget/view");
const icons_1 = require("../icons");
const styles_1 = require("./styles");
const Alert = (props) => {
    const { alertType, headerCopy, descriptionCopy } = props;
    const iconSize = 20;
    if (!headerCopy && !descriptionCopy) {
        return null;
    }
    return (react_1.default.createElement(styles_1.AlertContainer, Object.assign({}, props),
        react_1.default.createElement(styles_1.AlertIconContainer, null,
            react_1.default.createElement(icons_1.RioAlertIcon, { alertType: alertType, size: iconSize })),
        headerCopy ? (react_1.default.createElement(styles_1.AlertHeading, { bold: true, headingLevel: 4, iconSize: iconSize }, headerCopy)) : (react_1.default.createElement("br", null)),
        descriptionCopy && react_1.default.createElement(styles_1.AlertDescription, null, (0, view_1.SafeHtmlParse)(descriptionCopy))));
};
exports.Alert = Alert;
